export function getHeaderCourseDetails(state = 'Iniciados', action) {
  if (action.type === 'GET_HEADER_COURSE_DETAILS') {
    return action.headerName;
  }
  return state;
}
